import React, { useMemo } from 'react';
import { StatsDetailType } from '../..';
import { KeywordItem } from '@/pages/opinion/pages/Performance/components/TopicKeyword/components';
import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelLanguageChart from '@/pages/opinion/pages/Performance/components/ChannelsLanguageChart';
import RegionMarketChart from '@/pages/opinion/pages/Performance/components/RegionMarket/mentions';
import MentionsCharts from '../../../components/MentionsCharts';
import TimelineOfMentionsCharts from '../../../components/TimelineOfMentionsCharts';
import SentimentCharts from '../../../components/SentimentCharts';
import TimelineOfSentimentCharts from '../../../components/TimelineOfSentimentCharts';
import { Col, Row } from 'tea-component';

export default function Charts({
  statsDetailType,
  statsDetailChartsData,
  filter,
  handleStatsDetailOnClick,
  defaultSelected = '',
  rankBy
}: {
  statsDetailType: StatsDetailType;
  statsDetailChartsData: any;
  filter: any;
  handleStatsDetailOnClick: any;
  defaultSelected: string;
  rankBy?: string | null;
}) {
  // console.log(statsDetailType, 'statsDetailType', defaultSelected);
  const map: {
    [key in StatsDetailType]?: JSX.Element;
  } = {
    'performance-keyword': <></>,
    'competitor-keyword': <></>,
    'competitor-topic': <></>,
    'influencer-keyword': <></>,

    // 通用 keyword 折线图
    'performance-keyword-timeline': (
      <CardCommon>
        <KeywordItem
          data={statsDetailChartsData.data}
          filter={filter}
          handleStatsDetailOnClick={handleStatsDetailOnClick}
        ></KeywordItem>
      </CardCommon>
    ),
    'performance-language': (
      <CardCommon>
        <ChannelLanguageChart
          dataType="language"
          data={statsDetailChartsData.data}
          showTitle={false}
          loading={false}
          filter={filter}
          lang={statsDetailChartsData.lang}
          isVersion={false}
          type={statsDetailChartsData.type}
          defaultSelected={defaultSelected}
          chartOptions={{ selectedMode: true }}
          statsDetailType="performance-language"
          handleStatsDetailOnClick={handleStatsDetailOnClick}
        ></ChannelLanguageChart>
      </CardCommon>
    ),
    'steam-ratings-language': (
      <CardCommon>
        <ChannelLanguageChart
          dataType="language"
          data={statsDetailChartsData.data}
          showTitle={false}
          loading={false}
          filter={filter}
          lang={statsDetailChartsData.lang}
          isVersion={false}
          type={statsDetailChartsData.type}
          defaultSelected={defaultSelected}
          chartOptions={{ selectedMode: true }}
          statsDetailType="steam-ratings-language"
          handleStatsDetailOnClick={handleStatsDetailOnClick}
          rankBy={rankBy}
        ></ChannelLanguageChart>
      </CardCommon>
    ),
    'steam-insights-language': (
      <CardCommon>
        <ChannelLanguageChart
          dataType="language"
          data={statsDetailChartsData.data}
          showTitle={false}
          loading={false}
          filter={filter}
          lang={statsDetailChartsData.lang}
          isVersion={false}
          type={statsDetailChartsData.type}
          defaultSelected={defaultSelected}
          chartOptions={{ selectedMode: true }}
          statsDetailType="steam-insights-language"
          handleStatsDetailOnClick={handleStatsDetailOnClick}
        ></ChannelLanguageChart>
      </CardCommon>
    ),
    'performance-channel': (
      <CardCommon>
        <ChannelLanguageChart
          dataType="channel"
          data={statsDetailChartsData.data}
          showTitle={false}
          loading={false}
          filter={filter}
          defaultSelected={defaultSelected}
          chartOptions={{ selectedMode: true }}
          lang={statsDetailChartsData.lang}
          isVersion={false}
          type={statsDetailChartsData.type}
          // pieLabelAlignTo="labelLine"
          statsDetailType="performance-channel"
          handleStatsDetailOnClick={handleStatsDetailOnClick}
        ></ChannelLanguageChart>
      </CardCommon>
    ),
    'performance-region': (
      <RegionMarketChart
        data={statsDetailChartsData.data}
        filter={filter}
        dataType={statsDetailChartsData.dataType}
        type={statsDetailChartsData.type}
        defaultSelected={defaultSelected}
        chartOptions={{ selectedMode: true }}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        regionType={statsDetailChartsData.dataType}
      ></RegionMarketChart>
    ),
    'performance-market': (
      <RegionMarketChart
        data={statsDetailChartsData.data}
        filter={filter}
        defaultSelected={defaultSelected}
        chartOptions={{ selectedMode: true }}
        dataType={statsDetailChartsData.dataType}
        type={statsDetailChartsData.type}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        regionType={statsDetailChartsData.dataType}
      ></RegionMarketChart>
    ),
    'stats-mentions': (
      <MentionsCharts
        filter={filter}
        data={statsDetailChartsData.data}
        dataType={statsDetailChartsData.dataType}
        loading={false}
        defaultSelected={defaultSelected}
        chartOptions={{ selectedMode: true }}
        isVersion={statsDetailChartsData.isVersion}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        type={statsDetailChartsData.type}
      ></MentionsCharts>
    ),
    'stats-timeline-of-mentions': (
      <TimelineOfMentionsCharts
        filter={filter}
        data={statsDetailChartsData.data}
        dataType={statsDetailChartsData.dataType}
        loading={false}
        isVersion={statsDetailChartsData.isVersion}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        type={statsDetailChartsData.type}
      ></TimelineOfMentionsCharts>
    ),
    'stats-sentiment': (
      <SentimentCharts
        filter={filter}
        data={statsDetailChartsData.data}
        dataType={statsDetailChartsData.dataType}
        loading={false}
        isVersion={statsDetailChartsData.isVersion}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        type={statsDetailChartsData.type}
      ></SentimentCharts>
    ),
    'stats-timeline-of-sentiment': (
      <TimelineOfSentimentCharts
        filter={filter}
        data={statsDetailChartsData.data}
        dataType={statsDetailChartsData.dataType}
        loading={false}
        isVersion={statsDetailChartsData.isVersion}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        type={statsDetailChartsData.type}
      ></TimelineOfSentimentCharts>
    ),
  };

  const renderComopent = useMemo(() => {
    return map[statsDetailType] || <></>;
  }, [statsDetailType, statsDetailChartsData]);

  return (
    <Row className="details-card">
      <Col>{renderComopent} </Col>
    </Row>
  );
}
